import { Component, Input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { BusinessFuel } from '../../business/models/business-fuel.model';


@Component({
  selector: 'app-fuel-badge',
  templateUrl: './fuel-badge.component.html',
  styleUrls: ['./fuel-badge.component.scss']
})
export class FuelBadgeComponent {
  @Input() fuel: BusinessFuel;

  constructor (private _currencyPipe: CurrencyPipe) {}

  /**
   * Returns the text to display for fuel information
   */
  get fuelText(): string {
    return [
      this._currencyPipe.transform(this.fuel.price, 'USD'),
      BusinessFuel.formatFuelType(this.fuel.fuelType),
      BusinessFuel.formatServiceTypeShort(this.fuel.service)
    ].filter(v => v).join(' | ');
  }
}
